import React from "react";

const UKsNo1 = () => {
  return (
    <div className="inline-flex justify-center items-center gap-1 lg:min-w-[328px] border border-[#A9E2AC] bg-[#ECF9ED] px-3 lg:px-2 py-1 rounded-md border-solid font-jost lg:shadow-[0_2px_2px_rgba(0,0,0,0.7)]">
      <img
        src="/assets/images/car-competition/tabler-icon-discount-check-filled.svg"
        alt=""
        className="size-4 lg:size-6 shrink-0 aspect-[1/1]"
      />
      <span className="text-[#256929] text-center text-xs lg:text-lg font-normal leading-4 lg:leading-6">
        <span className="font-semibold">UK&apos;s No.1</span>
        <span> – Over 989k Winners</span>
      </span>
    </div>
  );
};

export default UKsNo1;
